import { generatePath } from "react-router";
import { credentialsPathPatterns } from "@/features/credentials/routes/credentials-path-patterns";
import { organizationsPathPatterns } from "@/features/organizations/routes/organizations-path-patterns";
import { seasonsPathPatterns } from "@/features/seasons/routes/seasons-path-patterns";

export type OrgScopedRouteParams = {
  customerId: number;
  organizationId: string;
  sport: string;
};

export const PathPatterns = {
  customers: {
    list: "/customers",
    home: "/customers/:customerId",
  },
  organizations: organizationsPathPatterns,
  credentials: credentialsPathPatterns,
  seasons: seasonsPathPatterns,
} as const;

export const RoutePaths = {
  customers: {
    list: () => PathPatterns.customers.list,
    home: ({ customerId }: { customerId: number }) =>
      generatePath(PathPatterns.customers.home, { customerId: String(customerId) }),
  },
  organizations: {
    list: ({ customerId }: { customerId: number }) =>
      generatePath(PathPatterns.organizations.list, { customerId: String(customerId) }),
  },
  credentials: {
    list: ({ customerId, organizationId, sport }: OrgScopedRouteParams) =>
      generatePath(PathPatterns.credentials.list, {
        customerId: String(customerId),
        organizationId,
        sport,
      }),
    create: ({
      customerId,
      organizationId,
      sport,
    }: {
      customerId: number;
      organizationId: string;
      sport: string;
    }) =>
      generatePath(`${PathPatterns.credentials.list}/${PathPatterns.credentials.create}`, {
        customerId: String(customerId),
        organizationId,
        sport,
      }),
    info: ({
      customerId,
      organizationId,
      sport,
      credentialId,
    }: {
      customerId: number;
      organizationId: string;
      sport: string;
      credentialId: string;
    }) =>
      generatePath(`${PathPatterns.credentials.list}/${PathPatterns.credentials.info}`, {
        customerId: String(customerId),
        organizationId,
        sport,
        credentialId,
      }),
    edit: ({
      customerId,
      organizationId,
      sport,
      credentialId,
    }: {
      customerId: number;
      organizationId: string;
      sport: string;
      credentialId: string;
    }) =>
      generatePath(`${PathPatterns.credentials.list}/${PathPatterns.credentials.edit}`, {
        customerId: String(customerId),
        organizationId,
        sport,
        credentialId,
      }),
  },
  seasons: {
    list: ({ customerId, organizationId, sport }: OrgScopedRouteParams) =>
      generatePath(PathPatterns.seasons.list, {
        customerId: String(customerId),
        organizationId,
        sport,
      }),
  },
} as const;
